import {AbstractFilter} from './AbstractFilter';
import {Session} from 'com/gongxigames/math/core/game/session/Session';
import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {Bonus} from 'com/gongxigames/math/core/game/engine/bonus/Bonus';

export class ScatterAnticipatorFilter extends AbstractFilter {
    protected scatterNeeded: number;
    protected scatterIndexFromMath: number;

    constructor(name: string, scatterNeeded: number, scatterIndexFromMath: number) {
        super(name);
        this.scatterNeeded = scatterNeeded;
        this.scatterIndexFromMath = scatterIndexFromMath;
    }

    public filter(response: Message, session: Session): boolean {
        const action = response.getAction();

        if (action !== Action.SPIN && action !== Action.FREESPIN && action !== Action.RESPIN &&
            // @ts-ignore TODO: refactoring required!
            action !== Action.MINISPIN
        ) {
            return true;
        }

        const spin = this.getSpin(response);
        const bonus = session.getBonus(Bonus.FREE_GAMES_BONUS);
        const self = this;
        let scatterAmount = 0;

        spin.symbolIds.forEach(function(reel: number[]) {
            reel.forEach(function(symbol: number) {
                if (symbol === self.scatterIndexFromMath) {
                    scatterAmount++;
                }
            });
        });

        return this.scatterNeeded === scatterAmount && bonus !== null;
    }
}
